import { Button } from "@/src/components/button";
import { CustomLink } from "@/src/components/custom-link";
import { cn } from "@/src/utils/shadcn";
import Image from "next/image";
export interface IsoFooterCardProps {
   img: string;
}

export function IsoFooterCard({ img }: IsoFooterCardProps) {
   return (
      <div className="flex items-center gap-6 h-full dark:filter  dark:invert dark:brightness-0 dark:contrast-100">
         {/* {title} */}
         <Image
            className="scale-150"
            src={img}
            alt={"title"}
            width={400}
            height={200}
         />
      </div>
   );
}
